import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { AppUtils } from '../../../core/config/app.utils';
import { NgOtpInputComponent } from 'ng-otp-input';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  @ViewChild(NgOtpInputComponent, { static: false }) ngOtpInput:
    | NgOtpInputComponent
    | any;
  loginForm: any;
  formErrors: any = {};
  loginSubscription = new Subscription();
  isError: any = {
    status: false,
    message: '',
  };
  passwordVisible = true;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router
  ) {
    this.formErrors = {
      email: {},
      password: {},
    };
  }

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
    });
    this.loginForm.valueChanges.subscribe((form: any) => {
      this.formErrors = AppUtils.getFormErrors(this.loginForm, this.formErrors);
    });
    this.loginSubscription = this.authService
      .getLoggedInStatus()
      .subscribe(({ isAuthenticated }) => {
        if (isAuthenticated) {
          this.router.navigate(['/admin']);
        }
      });
  }

  async onLogin(): Promise<any> {
    if (this.loginForm.invalid) {
      return false;
    }
    const { email, password } = this.loginForm.getRawValue();
    try {
      await this.authService.login(email, password);
    } catch (e) {
      this.isError.status = true;
      this.isError.message = e;
    }
  }
}
